export default __webpack_public_path__ + "static/media/og-default.1c1a62c6.png";